module.exports = __webpack_public_path__ + "img/female10.147a810f.jpeg";